__turbopack_context__.v({
  "container": "dealMobileCard-module-scss-module__0BkQJG__container",
  "content": "dealMobileCard-module-scss-module__0BkQJG__content",
  "label": "dealMobileCard-module-scss-module__0BkQJG__label",
  "row": "dealMobileCard-module-scss-module__0BkQJG__row",
  "title": "dealMobileCard-module-scss-module__0BkQJG__title",
  "value": "dealMobileCard-module-scss-module__0BkQJG__value",
});
